import { AppNS } from 'app';
import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

export const checkValidation = (value: RadioQuestion[]) => {
  if (value.find((item) => item.state === null)) {
    return false;
  } else {
    return true;
  }
};

export const checkFailMatrix = (
  value: RadioQuestion[],
  matrix: boolean[] | null[]
): boolean => {
  return value.find(
    (item, index) => parseStateToBoolean(item.state) === matrix[index]
  )
    ? true
    : false;
};

export const parseQuestionnaire = (
  report: AppNS.JobEventReport,
  questionsList: RadioQuestion[]
): RadioQuestion[] => {
  if (
    !report ||
    !report.inspectionQuestionnaire ||
    Object.keys(report.inspectionQuestionnaire).length === 0
  ) {
    return questionsList;
  }

  return questionsList.map((q) => {
    if (report.inspectionQuestionnaire) {
      const result = report.inspectionQuestionnaire[q.id];
      if (result) {
        return { ...q, state: result };
      }
    }
    return { ...q, state: false };
  });
};

export const parseQuestionnaireOutput = (
  questionsList: RadioQuestion[]
): AppNS.Params => {
  let output: AppNS.Params = {};

  questionsList.forEach((q) => {
    output[q.id] = q.state === 'yes' ? 'yes' : 'no';
  });

  return output;
};

export const checkIfEditable = (
  report: AppNS.JobEventReport,
  canEdit: boolean
): boolean => {
  if (!report || !canEdit) {
    return false;
  }

  if (
    report.inspectionQuestionnaire === null ||
    Object.keys(report.inspectionQuestionnaire).length === 0
  ) {
    return true;
  }

  return false;
};

const parseStateToBoolean = (state: string | null): boolean => {
  return state === 'yes';
};
